/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { activitiesByProfileId } from '../fn/profile/activities-by-profile-id';
import { ActivitiesByProfileId$Params } from '../fn/profile/activities-by-profile-id';
import { ActivityResponse } from '../models/activity-response';
import { ActivityTypesActivities } from '../models/activity-types-activities';
import { activityTypesById } from '../fn/profile/activity-types-by-id';
import { ActivityTypesById$Params } from '../fn/profile/activity-types-by-id';
import { BooleanResponse } from '../models/boolean-response';
import { changeAdvanceSettingsByProfileId } from '../fn/profile/change-advance-settings-by-profile-id';
import { ChangeAdvanceSettingsByProfileId$Params } from '../fn/profile/change-advance-settings-by-profile-id';
import { ChargebeeResponse } from '../models/chargebee-response';
import { createProfile } from '../fn/profile/create-profile';
import { CreateProfile$Params } from '../fn/profile/create-profile';
import { createProfileStatsHistorySnapshot } from '../fn/profile/create-profile-stats-history-snapshot';
import { CreateProfileStatsHistorySnapshot$Params } from '../fn/profile/create-profile-stats-history-snapshot';
import { deleteProfileById } from '../fn/profile/delete-profile-by-id';
import { DeleteProfileById$Params } from '../fn/profile/delete-profile-by-id';
import { filesByProfileId } from '../fn/profile/files-by-profile-id';
import { FilesByProfileId$Params } from '../fn/profile/files-by-profile-id';
import { followByProfileId } from '../fn/profile/follow-by-profile-id';
import { FollowByProfileId$Params } from '../fn/profile/follow-by-profile-id';
import { galleryByProfileId } from '../fn/profile/gallery-by-profile-id';
import { GalleryByProfileId$Params } from '../fn/profile/gallery-by-profile-id';
import { getCompanyFromChargebee } from '../fn/profile/get-company-from-chargebee';
import { GetCompanyFromChargebee$Params } from '../fn/profile/get-company-from-chargebee';
import { getProfileAdmins } from '../fn/profile/get-profile-admins';
import { GetProfileAdmins$Params } from '../fn/profile/get-profile-admins';
import { getProfileAuditors } from '../fn/profile/get-profile-auditors';
import { GetProfileAuditors$Params } from '../fn/profile/get-profile-auditors';
import { getProfileById } from '../fn/profile/get-profile-by-id';
import { GetProfileById$Params } from '../fn/profile/get-profile-by-id';
import { getProfileCheckoutUniqueLink } from '../fn/profile/get-profile-checkout-unique-link';
import { GetProfileCheckoutUniqueLink$Params } from '../fn/profile/get-profile-checkout-unique-link';
import { getProfilePortalAccessUrl } from '../fn/profile/get-profile-portal-access-url';
import { GetProfilePortalAccessUrl$Params } from '../fn/profile/get-profile-portal-access-url';
import { getProfileReporters } from '../fn/profile/get-profile-reporters';
import { GetProfileReporters$Params } from '../fn/profile/get-profile-reporters';
import { getProfileSubscriptions } from '../fn/profile/get-profile-subscriptions';
import { GetProfileSubscriptions$Params } from '../fn/profile/get-profile-subscriptions';
import { getRandomActivitiesForProfile } from '../fn/profile/get-random-activities-for-profile';
import { GetRandomActivitiesForProfile$Params } from '../fn/profile/get-random-activities-for-profile';
import { getRandomActivitiesForProfileWithExclude } from '../fn/profile/get-random-activities-for-profile-with-exclude';
import { GetRandomActivitiesForProfileWithExclude$Params } from '../fn/profile/get-random-activities-for-profile-with-exclude';
import { IndustryGroupWithProfiles } from '../models/industry-group-with-profiles';
import { listIndustryGroupsWithProfiles } from '../fn/profile/list-industry-groups-with-profiles';
import { ListIndustryGroupsWithProfiles$Params } from '../fn/profile/list-industry-groups-with-profiles';
import { listProfileCountries } from '../fn/profile/list-profile-countries';
import { ListProfileCountries$Params } from '../fn/profile/list-profile-countries';
import { listProfileRandom } from '../fn/profile/list-profile-random';
import { ListProfileRandom$Params } from '../fn/profile/list-profile-random';
import { listProfiles } from '../fn/profile/list-profiles';
import { ListProfiles$Params } from '../fn/profile/list-profiles';
import { listProfilesByActive } from '../fn/profile/list-profiles-by-active';
import { ListProfilesByActive$Params } from '../fn/profile/list-profiles-by-active';
import { listProfilesByScore } from '../fn/profile/list-profiles-by-score';
import { ListProfilesByScore$Params } from '../fn/profile/list-profiles-by-score';
import { listProfilesInIndustryGroup } from '../fn/profile/list-profiles-in-industry-group';
import { ListProfilesInIndustryGroup$Params } from '../fn/profile/list-profiles-in-industry-group';
import { MostActiveProfilesResponse } from '../models/most-active-profiles-response';
import { NumberResponse } from '../models/number-response';
import { patchProfileById } from '../fn/profile/patch-profile-by-id';
import { PatchProfileById$Params } from '../fn/profile/patch-profile-by-id';
import { patchProfileSecurityById } from '../fn/profile/patch-profile-security-by-id';
import { PatchProfileSecurityById$Params } from '../fn/profile/patch-profile-security-by-id';
import { ProfileActivitiesResponse } from '../models/profile-activities-response';
import { ProfileFile } from '../models/profile-file';
import { ProfileResponse } from '../models/profile-response';
import { ProfileSimple } from '../models/profile-simple';
import { ProfileWithStatistics } from '../models/profile-with-statistics';
import { PurchaseCheckoutResponse } from '../models/purchase-checkout-response';
import { PurchasePortalResponse } from '../models/purchase-portal-response';
import { ResponseProfileCountries } from '../models/response-profile-countries';
import { ResponseProfileStatistics } from '../models/response-profile-statistics';
import { statisticsByProfileId } from '../fn/profile/statistics-by-profile-id';
import { StatisticsByProfileId$Params } from '../fn/profile/statistics-by-profile-id';
import { updateProfileById } from '../fn/profile/update-profile-by-id';
import { UpdateProfileById$Params } from '../fn/profile/update-profile-by-id';
import { updateProfileCoverById } from '../fn/profile/update-profile-cover-by-id';
import { UpdateProfileCoverById$Params } from '../fn/profile/update-profile-cover-by-id';
import { updateProfileLogoById } from '../fn/profile/update-profile-logo-by-id';
import { UpdateProfileLogoById$Params } from '../fn/profile/update-profile-logo-by-id';
import { UserTag } from '../models/user-tag';

@Injectable({ providedIn: 'root' })
export class ProfileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createProfile()` */
  static readonly CreateProfilePath = '/rest/profile';

  /**
   * Create new profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProfile$Response(params: CreateProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return createProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProfile(params: CreateProfile$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.createProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

  /** Path part for operation `listProfiles()` */
  static readonly ListProfilesPath = '/rest/profile/{offset}/{limit}';

  /**
   * Lisrt all profiles with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfiles$Response(params: ListProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
    return listProfiles(this.http, this.rootUrl, params, context);
  }

  /**
   * Lisrt all profiles with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfiles(params: ListProfiles$Params, context?: HttpContext): Observable<Array<ProfileResponse>> {
    return this.listProfiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileResponse>>): Array<ProfileResponse> => r.body)
    );
  }

  /** Path part for operation `listProfileRandom()` */
  static readonly ListProfileRandomPath = '/rest/profile/random/{max}/{minActivities}';

  /**
   * Get list of random profiles. Parameter MAX define how many profiles to return.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfileRandom()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileRandom$Response(params: ListProfileRandom$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileSimple>>> {
    return listProfileRandom(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of random profiles. Parameter MAX define how many profiles to return.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfileRandom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileRandom(params: ListProfileRandom$Params, context?: HttpContext): Observable<Array<ProfileSimple>> {
    return this.listProfileRandom$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileSimple>>): Array<ProfileSimple> => r.body)
    );
  }

  /** Path part for operation `listProfileCountries()` */
  static readonly ListProfileCountriesPath = '/rest/profile/list-profile-countries/{companyType}/{language}';

  /**
   * Get list of profiles countries. Returned are only countries which has assigned as least one profile (each profile must have at least one activity where is organizer). Returned is also count of profiles which are assigned to country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfileCountries()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileCountries$Response(params: ListProfileCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseProfileCountries>>> {
    return listProfileCountries(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of profiles countries. Returned are only countries which has assigned as least one profile (each profile must have at least one activity where is organizer). Returned is also count of profiles which are assigned to country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfileCountries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileCountries(params: ListProfileCountries$Params, context?: HttpContext): Observable<Array<ResponseProfileCountries>> {
    return this.listProfileCountries$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseProfileCountries>>): Array<ResponseProfileCountries> => r.body)
    );
  }

  /** Path part for operation `createProfileStatsHistorySnapshot()` */
  static readonly CreateProfileStatsHistorySnapshotPath = '/rest/profile/create-profile-stats-history-snapshot';

  /**
   * Create historical snapshot of profile statistics. Needs to be SH admin to call this service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProfileStatsHistorySnapshot()` instead.
   *
   * This method doesn't expect any request body.
   */
  createProfileStatsHistorySnapshot$Response(params?: CreateProfileStatsHistorySnapshot$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return createProfileStatsHistorySnapshot(this.http, this.rootUrl, params, context);
  }

  /**
   * Create historical snapshot of profile statistics. Needs to be SH admin to call this service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProfileStatsHistorySnapshot$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createProfileStatsHistorySnapshot(params?: CreateProfileStatsHistorySnapshot$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.createProfileStatsHistorySnapshot$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `listProfilesByScore()` */
  static readonly ListProfilesByScorePath = '/rest/profile/rank/score/{offset}/{limit}';

  /**
   * Get list of profiles (profile must have at least 3 activity where is organizer) sorted by score (e.g. rank). Offset and limit is mandatory. CompanyType/country is optional filter (use value 'null' for no industry/country filter). Country can be only one, company types multiple.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfilesByScore()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfilesByScore$Response(params: ListProfilesByScore$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileWithStatistics>>> {
    return listProfilesByScore(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of profiles (profile must have at least 3 activity where is organizer) sorted by score (e.g. rank). Offset and limit is mandatory. CompanyType/country is optional filter (use value 'null' for no industry/country filter). Country can be only one, company types multiple.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfilesByScore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfilesByScore(params: ListProfilesByScore$Params, context?: HttpContext): Observable<Array<ProfileWithStatistics>> {
    return this.listProfilesByScore$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileWithStatistics>>): Array<ProfileWithStatistics> => r.body)
    );
  }

  /** Path part for operation `listProfilesByActive()` */
  static readonly ListProfilesByActivePath = '/rest/profile/rank/most-active/{daysBefore}/{offset}/{limit}';

  /**
   * Get list of profiles (profile must have at least 3 activity where is organizer) sorted by most active (e.g. how manty activities has been add in last X days). Offset and limit is mandatory. CompanyType/country is optional filter (use value 'null' for no industry/country filter).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfilesByActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfilesByActive$Response(params: ListProfilesByActive$Params, context?: HttpContext): Observable<StrictHttpResponse<MostActiveProfilesResponse>> {
    return listProfilesByActive(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of profiles (profile must have at least 3 activity where is organizer) sorted by most active (e.g. how manty activities has been add in last X days). Offset and limit is mandatory. CompanyType/country is optional filter (use value 'null' for no industry/country filter).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfilesByActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfilesByActive(params: ListProfilesByActive$Params, context?: HttpContext): Observable<MostActiveProfilesResponse> {
    return this.listProfilesByActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<MostActiveProfilesResponse>): MostActiveProfilesResponse => r.body)
    );
  }

  /** Path part for operation `listIndustryGroupsWithProfiles()` */
  static readonly ListIndustryGroupsWithProfilesPath = '/rest/profile/rank/industry-group';

  /**
   * Get list of industry groups with profiles with statistics. MaxProfiles parameter is optional.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listIndustryGroupsWithProfiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  listIndustryGroupsWithProfiles$Response(params?: ListIndustryGroupsWithProfiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IndustryGroupWithProfiles>>> {
    return listIndustryGroupsWithProfiles(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of industry groups with profiles with statistics. MaxProfiles parameter is optional.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listIndustryGroupsWithProfiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listIndustryGroupsWithProfiles(params?: ListIndustryGroupsWithProfiles$Params, context?: HttpContext): Observable<Array<IndustryGroupWithProfiles>> {
    return this.listIndustryGroupsWithProfiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<IndustryGroupWithProfiles>>): Array<IndustryGroupWithProfiles> => r.body)
    );
  }

  /** Path part for operation `listProfilesInIndustryGroup()` */
  static readonly ListProfilesInIndustryGroupPath = '/rest/profile/rank/industry-group/{industryGroup}';

  /**
   * Get list of profiles in industry group. Industry group is mandatory. Offset and limit is optional.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfilesInIndustryGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfilesInIndustryGroup$Response(params: ListProfilesInIndustryGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileWithStatistics>>> {
    return listProfilesInIndustryGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of profiles in industry group. Industry group is mandatory. Offset and limit is optional.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfilesInIndustryGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfilesInIndustryGroup(params: ListProfilesInIndustryGroup$Params, context?: HttpContext): Observable<Array<ProfileWithStatistics>> {
    return this.listProfilesInIndustryGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileWithStatistics>>): Array<ProfileWithStatistics> => r.body)
    );
  }

  /** Path part for operation `getProfileById()` */
  static readonly GetProfileByIdPath = '/rest/profile/{id}';

  /**
   * Get profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileById$Response(params: GetProfileById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return getProfileById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfileById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileById(params: GetProfileById$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.getProfileById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

  /** Path part for operation `updateProfileById()` */
  static readonly UpdateProfileByIdPath = '/rest/profile/{id}';

  /**
   * Update existing profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProfileById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfileById$Response(params: UpdateProfileById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return updateProfileById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProfileById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfileById(params: UpdateProfileById$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.updateProfileById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

  /** Path part for operation `deleteProfileById()` */
  static readonly DeleteProfileByIdPath = '/rest/profile/{id}';

  /**
   * Delete profile by id (if profile has been deleted, nothing will change) and all activities where profile is organizer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProfileById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProfileById$Response(params: DeleteProfileById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return deleteProfileById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete profile by id (if profile has been deleted, nothing will change) and all activities where profile is organizer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProfileById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProfileById(params: DeleteProfileById$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.deleteProfileById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

  /** Path part for operation `patchProfileById()` */
  static readonly PatchProfileByIdPath = '/rest/profile/{id}';

  /**
   * Patch existing profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchProfileById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchProfileById$Response(params: PatchProfileById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return patchProfileById(this.http, this.rootUrl, params, context);
  }

  /**
   * Patch existing profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchProfileById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchProfileById(params: PatchProfileById$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.patchProfileById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

  /** Path part for operation `getProfileAdmins()` */
  static readonly GetProfileAdminsPath = '/rest/profile/{id}/admins';

  /**
   * Get profile admins (required is logged user, profile admin).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileAdmins()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileAdmins$Response(params: GetProfileAdmins$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTag>>> {
    return getProfileAdmins(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profile admins (required is logged user, profile admin).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfileAdmins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileAdmins(params: GetProfileAdmins$Params, context?: HttpContext): Observable<Array<UserTag>> {
    return this.getProfileAdmins$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserTag>>): Array<UserTag> => r.body)
    );
  }

  /** Path part for operation `getProfileReporters()` */
  static readonly GetProfileReportersPath = '/rest/profile/{id}/reporters';

  /**
   * Get profile reporters (required is logged user, profile admin).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileReporters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileReporters$Response(params: GetProfileReporters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTag>>> {
    return getProfileReporters(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profile reporters (required is logged user, profile admin).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfileReporters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileReporters(params: GetProfileReporters$Params, context?: HttpContext): Observable<Array<UserTag>> {
    return this.getProfileReporters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserTag>>): Array<UserTag> => r.body)
    );
  }

  /** Path part for operation `getProfileAuditors()` */
  static readonly GetProfileAuditorsPath = '/rest/profile/{id}/auditors';

  /**
   * Get profile auditors (required is logged user, profile admin).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileAuditors()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileAuditors$Response(params: GetProfileAuditors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTag>>> {
    return getProfileAuditors(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profile auditors (required is logged user, profile admin).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfileAuditors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileAuditors(params: GetProfileAuditors$Params, context?: HttpContext): Observable<Array<UserTag>> {
    return this.getProfileAuditors$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserTag>>): Array<UserTag> => r.body)
    );
  }

  /** Path part for operation `updateProfileLogoById()` */
  static readonly UpdateProfileLogoByIdPath = '/rest/profile/{id}/logo';

  /**
   * Update existing profile logo by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProfileLogoById()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateProfileLogoById$Response(params: UpdateProfileLogoById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return updateProfileLogoById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing profile logo by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProfileLogoById$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateProfileLogoById(params: UpdateProfileLogoById$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.updateProfileLogoById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

  /** Path part for operation `updateProfileCoverById()` */
  static readonly UpdateProfileCoverByIdPath = '/rest/profile/{id}/cover';

  /**
   * Update existing profile cover by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProfileCoverById()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateProfileCoverById$Response(params: UpdateProfileCoverById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return updateProfileCoverById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing profile cover by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProfileCoverById$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateProfileCoverById(params: UpdateProfileCoverById$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.updateProfileCoverById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

  /** Path part for operation `patchProfileSecurityById()` */
  static readonly PatchProfileSecurityByIdPath = '/rest/profile/{id}/security';

  /**
   * Update security settings for existing profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchProfileSecurityById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchProfileSecurityById$Response(params: PatchProfileSecurityById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchProfileSecurityById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update security settings for existing profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchProfileSecurityById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchProfileSecurityById(params: PatchProfileSecurityById$Params, context?: HttpContext): Observable<void> {
    return this.patchProfileSecurityById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `activitiesByProfileId()` */
  static readonly ActivitiesByProfileIdPath = '/rest/profile/{profileId}/activities/{offset}/{limit}';

  /**
   * Public service to get profile activities.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activitiesByProfileId()` instead.
   *
   * This method doesn't expect any request body.
   */
  activitiesByProfileId$Response(params: ActivitiesByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileActivitiesResponse>> {
    return activitiesByProfileId(this.http, this.rootUrl, params, context);
  }

  /**
   * Public service to get profile activities.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activitiesByProfileId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activitiesByProfileId(params: ActivitiesByProfileId$Params, context?: HttpContext): Observable<ProfileActivitiesResponse> {
    return this.activitiesByProfileId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileActivitiesResponse>): ProfileActivitiesResponse => r.body)
    );
  }

  /** Path part for operation `filesByProfileId()` */
  static readonly FilesByProfileIdPath = '/rest/profile/{profileId}/files';

  /**
   * Public service to get profile files.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filesByProfileId()` instead.
   *
   * This method doesn't expect any request body.
   */
  filesByProfileId$Response(params: FilesByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileFile>>> {
    return filesByProfileId(this.http, this.rootUrl, params, context);
  }

  /**
   * Public service to get profile files.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filesByProfileId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filesByProfileId(params: FilesByProfileId$Params, context?: HttpContext): Observable<Array<ProfileFile>> {
    return this.filesByProfileId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileFile>>): Array<ProfileFile> => r.body)
    );
  }

  /** Path part for operation `statisticsByProfileId()` */
  static readonly StatisticsByProfileIdPath = '/rest/profile/{profileId}/statistics';

  /**
   * Public service to get profile statistics.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsByProfileId()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsByProfileId$Response(params: StatisticsByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseProfileStatistics>> {
    return statisticsByProfileId(this.http, this.rootUrl, params, context);
  }

  /**
   * Public service to get profile statistics.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsByProfileId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsByProfileId(params: StatisticsByProfileId$Params, context?: HttpContext): Observable<ResponseProfileStatistics> {
    return this.statisticsByProfileId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseProfileStatistics>): ResponseProfileStatistics => r.body)
    );
  }

  /** Path part for operation `activityTypesById()` */
  static readonly ActivityTypesByIdPath = '/rest/profile/{profileId}/activity-types';

  /**
   * Public service to get profile activity types counts (which activity types has how many activities).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activityTypesById()` instead.
   *
   * This method doesn't expect any request body.
   */
  activityTypesById$Response(params: ActivityTypesById$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityTypesActivities>>> {
    return activityTypesById(this.http, this.rootUrl, params, context);
  }

  /**
   * Public service to get profile activity types counts (which activity types has how many activities).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activityTypesById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activityTypesById(params: ActivityTypesById$Params, context?: HttpContext): Observable<Array<ActivityTypesActivities>> {
    return this.activityTypesById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityTypesActivities>>): Array<ActivityTypesActivities> => r.body)
    );
  }

  /** Path part for operation `followByProfileId()` */
  static readonly FollowByProfileIdPath = '/rest/profile/{id}/follow';

  /**
   * Called can be onl by logged user. For logged user mark profile as 'followed' or remove if from following.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `followByProfileId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  followByProfileId$Response(params: FollowByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return followByProfileId(this.http, this.rootUrl, params, context);
  }

  /**
   * Called can be onl by logged user. For logged user mark profile as 'followed' or remove if from following.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `followByProfileId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  followByProfileId(params: FollowByProfileId$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.followByProfileId$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `galleryByProfileId()` */
  static readonly GalleryByProfileIdPath = '/rest/profile/{id}/gallery';

  /**
   * Get images for profile.
   *
   * Get 30 images for profile. Images are from activities - those activities must have profile as one of organizer ("profile activities"). Each round - from each profile activity are taken first 2 images but only till 30 images are are already taken (altogether). If limit of 30 images is fulfilled, than service is done. If not, another round is started. Rounds continue till there is limit of 30 images fulfilled or all images for profile activities are taken.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryByProfileId()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryByProfileId$Response(params: GalleryByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<NumberResponse>> {
    return galleryByProfileId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get images for profile.
   *
   * Get 30 images for profile. Images are from activities - those activities must have profile as one of organizer ("profile activities"). Each round - from each profile activity are taken first 2 images but only till 30 images are are already taken (altogether). If limit of 30 images is fulfilled, than service is done. If not, another round is started. Rounds continue till there is limit of 30 images fulfilled or all images for profile activities are taken.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryByProfileId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryByProfileId(params: GalleryByProfileId$Params, context?: HttpContext): Observable<NumberResponse> {
    return this.galleryByProfileId$Response(params, context).pipe(
      map((r: StrictHttpResponse<NumberResponse>): NumberResponse => r.body)
    );
  }

  /** Path part for operation `changeAdvanceSettingsByProfileId()` */
  static readonly ChangeAdvanceSettingsByProfileIdPath = '/rest/profile/{id}/advance-settings';

  /**
   * Service to change special profile settings. 1) showActivityTypesBar -> Show/Hide bar graph of activity tpes 2) showImpactGraph -> Show/Hide list of impacts (counted are all impact from all activities where profile is organizer) 3) disqusActive -> Show/Hide disqus comment system.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeAdvanceSettingsByProfileId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeAdvanceSettingsByProfileId$Response(params: ChangeAdvanceSettingsByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return changeAdvanceSettingsByProfileId(this.http, this.rootUrl, params, context);
  }

  /**
   * Service to change special profile settings. 1) showActivityTypesBar -> Show/Hide bar graph of activity tpes 2) showImpactGraph -> Show/Hide list of impacts (counted are all impact from all activities where profile is organizer) 3) disqusActive -> Show/Hide disqus comment system.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeAdvanceSettingsByProfileId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeAdvanceSettingsByProfileId(params: ChangeAdvanceSettingsByProfileId$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.changeAdvanceSettingsByProfileId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

  /** Path part for operation `getRandomActivitiesForProfile()` */
  static readonly GetRandomActivitiesForProfilePath = '/rest/profile/{id}/random-activities/{count}';

  /**
   * Get random activities for profile - count of returned activities is path parameter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRandomActivitiesForProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRandomActivitiesForProfile$Response(params: GetRandomActivitiesForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityResponse>>> {
    return getRandomActivitiesForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Get random activities for profile - count of returned activities is path parameter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRandomActivitiesForProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRandomActivitiesForProfile(params: GetRandomActivitiesForProfile$Params, context?: HttpContext): Observable<Array<ActivityResponse>> {
    return this.getRandomActivitiesForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityResponse>>): Array<ActivityResponse> => r.body)
    );
  }

  /** Path part for operation `getRandomActivitiesForProfileWithExclude()` */
  static readonly GetRandomActivitiesForProfileWithExcludePath = '/rest/profile/{id}/random-activities/{count}/{exclude}';

  /**
   * Get random activities for profile - count of returned activities is path parameter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRandomActivitiesForProfileWithExclude()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRandomActivitiesForProfileWithExclude$Response(params: GetRandomActivitiesForProfileWithExclude$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityResponse>>> {
    return getRandomActivitiesForProfileWithExclude(this.http, this.rootUrl, params, context);
  }

  /**
   * Get random activities for profile - count of returned activities is path parameter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRandomActivitiesForProfileWithExclude$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRandomActivitiesForProfileWithExclude(params: GetRandomActivitiesForProfileWithExclude$Params, context?: HttpContext): Observable<Array<ActivityResponse>> {
    return this.getRandomActivitiesForProfileWithExclude$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityResponse>>): Array<ActivityResponse> => r.body)
    );
  }

  /** Path part for operation `getCompanyFromChargebee()` */
  static readonly GetCompanyFromChargebeePath = '/rest/profile/{id}/purchase';

  /**
   * Get company from Chargebee. If customer is found in Chargebee - returns empty response.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyFromChargebee()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFromChargebee$Response(params: GetCompanyFromChargebee$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargebeeResponse>> {
    return getCompanyFromChargebee(this.http, this.rootUrl, params, context);
  }

  /**
   * Get company from Chargebee. If customer is found in Chargebee - returns empty response.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyFromChargebee$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFromChargebee(params: GetCompanyFromChargebee$Params, context?: HttpContext): Observable<ChargebeeResponse> {
    return this.getCompanyFromChargebee$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargebeeResponse>): ChargebeeResponse => r.body)
    );
  }

  /** Path part for operation `getProfileSubscriptions()` */
  static readonly GetProfileSubscriptionsPath = '/rest/profile/{id}/purchase/subscriptions';

  /**
   * Get list of all active subscriptions for profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileSubscriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileSubscriptions$Response(params: GetProfileSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargebeeResponse>>> {
    return getProfileSubscriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of all active subscriptions for profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfileSubscriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileSubscriptions(params: GetProfileSubscriptions$Params, context?: HttpContext): Observable<Array<ChargebeeResponse>> {
    return this.getProfileSubscriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChargebeeResponse>>): Array<ChargebeeResponse> => r.body)
    );
  }

  /** Path part for operation `getProfileCheckoutUniqueLink()` */
  static readonly GetProfileCheckoutUniqueLinkPath = '/rest/profile/{id}/purchase/checkout/{planId}';

  /**
   * Create access url for Chargbee Hosted Page - Checkout. Access url will open checkout for predefined profile + subscription/plan. Get plan by plan ID. Check if such profile exists. If profile has some existing active subscription than access url will not be generated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileCheckoutUniqueLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileCheckoutUniqueLink$Response(params: GetProfileCheckoutUniqueLink$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseCheckoutResponse>> {
    return getProfileCheckoutUniqueLink(this.http, this.rootUrl, params, context);
  }

  /**
   * Create access url for Chargbee Hosted Page - Checkout. Access url will open checkout for predefined profile + subscription/plan. Get plan by plan ID. Check if such profile exists. If profile has some existing active subscription than access url will not be generated.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfileCheckoutUniqueLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileCheckoutUniqueLink(params: GetProfileCheckoutUniqueLink$Params, context?: HttpContext): Observable<PurchaseCheckoutResponse> {
    return this.getProfileCheckoutUniqueLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<PurchaseCheckoutResponse>): PurchaseCheckoutResponse => r.body)
    );
  }

  /** Path part for operation `getProfilePortalAccessUrl()` */
  static readonly GetProfilePortalAccessUrlPath = '/rest/profile/{id}/purchase/portal';

  /**
   * Create access url for Chargbee Hosted Page - Portal. Access url will open portal for predefined profile. Check if such profile exists. If profile does not exists, it will be created (with email/first name/last name/company title).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfilePortalAccessUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfilePortalAccessUrl$Response(params: GetProfilePortalAccessUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchasePortalResponse>> {
    return getProfilePortalAccessUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * Create access url for Chargbee Hosted Page - Portal. Access url will open portal for predefined profile. Check if such profile exists. If profile does not exists, it will be created (with email/first name/last name/company title).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfilePortalAccessUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfilePortalAccessUrl(params: GetProfilePortalAccessUrl$Params, context?: HttpContext): Observable<PurchasePortalResponse> {
    return this.getProfilePortalAccessUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<PurchasePortalResponse>): PurchasePortalResponse => r.body)
    );
  }

}
